import { gql } from '@apollo/client';

// Legacy mutations (kept for backward compatibility during migration)
export const CREATE_SIGNUP_INTENT = gql`
  mutation createSignupIntent($input: CreateSignupIntentInput!) {
    createSignupIntent(input: $input) {
      success
      message
    }
  }
`;

export const VERIFY_SIGNUP_EMAIL = gql`
  mutation verifySignupEmail($token: String!) {
    verifySignupEmail(token: $token) {
      success
      message
      signupIntentId
    }
  }
`;

export const COMPLETE_SIGNUP_PAYMENT = gql`
  mutation completeSignupPayment($sessionId: String!) {
    completeSignupPayment(sessionId: $sessionId) {
      success
      message
      plan
    }
  }
`;

export const CREATE_GOOGLE_SIGNUP_CHECKOUT = gql`
  mutation createGoogleSignupCheckout(
    $signUpToken: String!
    $username: String!
    $plan: String!
    $isMonthly: Boolean
  ) {
    createGoogleSignupCheckout(
      signUpToken: $signUpToken
      username: $username
      plan: $plan
      isMonthly: $isMonthly
    ) {
      url
    }
  }
`;

// =============================================================================
// NEW OTP-BASED SIGNUP FLOW
// =============================================================================

// Step 1: Email + captcha → sends OTP, sets signup_session cookie
export const INITIATE_SIGNUP = gql`
  mutation initiateSignup($input: InitiateSignupInput!) {
    initiateSignup(input: $input) {
      success
      message
      stage
    }
  }
`;

// Step 2: Verify 5-digit OTP code
export const VERIFY_SIGNUP_OTP = gql`
  mutation verifySignupOtp($otp: Int!) {
    verifySignupOtp(otp: $otp) {
      success
      message
      stage
      code
    }
  }
`;

// Step 2b: Resend OTP (1-min cooldown)
export const RESEND_SIGNUP_OTP = gql`
  mutation resendSignupOtp {
    resendSignupOtp {
      success
      message
    }
  }
`;

// Google OAuth: Verify signup token, create intent, set cookie
export const INITIATE_GOOGLE_SIGNUP = gql`
  mutation initiateGoogleSignup($token: String!, $displayName: String, $profileImage: String) {
    initiateGoogleSignup(token: $token, displayName: $displayName, profileImage: $profileImage) {
      success
      message
      stage
    }
  }
`;

// Step 3: Set username + avatar (both flows)
export const SET_SIGNUP_PROFILE = gql`
  mutation setSignupProfile($input: SetSignupProfileInput!) {
    setSignupProfile(input: $input) {
      success
      message
      stage
      code
    }
  }
`;

// Step 4: Mark blog preview as seen
export const MARK_PREVIEW_SEEN = gql`
  mutation markPreviewSeen {
    markPreviewSeen {
      success
      message
      stage
    }
  }
`;

// Step 4b: Set password (email flow only)
export const SET_SIGNUP_PASSWORD = gql`
  mutation setSignupPassword($input: SetSignupPasswordInput!) {
    setSignupPassword(input: $input) {
      success
      message
      stage
    }
  }
`;

// Step 5: Get Stripe checkout URL (uses cookie for session)
export const GET_SIGNUP_CHECKOUT_URL = gql`
  mutation getSignupCheckoutUrl($plan: String!, $isMonthly: Boolean) {
    getSignupCheckoutUrl(plan: $plan, isMonthly: $isMonthly) {
      url
    }
  }
`;

// =============================================================================
// QUERIES
// =============================================================================

// Get signup session state from cookie
export const SIGNUP_SESSION = gql`
  query signupSession {
    signupSession {
      email
      displayName
      profileImage
      stage
      username
      authMethod
      canResendOtp
      otpExpiresIn
      recoveryDiscount
      createdAt
    }
  }
`;

// Featured travelers for community preview - hardcoded in frontend
// (same list as SocialProof.js on /join page)
export const FEATURED_TRAVELERS = [
  'mibreit-photo',
  'x-rain',
  'for91days',
  'cocuyeras',
  'koenau',
  'juancar347',
  'adambarratt',
  'kolibrarium',
];
